// The page around the app (redesign approved 20 Oct 2026): a sidebar on desktop, a bottom tab bar on phones,
// the page itself (#view, drawn by app.js, top bar included), dialogs and the toast.
import { LOGO_SVG } from './logo';

const ic = (body: string, size = 18) => `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${body}</svg>`;

/** Icons from the approved design (24×24, stroke 1.9). */
export const ICONS = {
  overview: '<rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>',
  stocks: '<path d="M4 20V10"/><path d="M10 20V4"/><path d="M16 20v-7"/><path d="M21 20H3"/>',
  crypto: '<circle cx="12" cy="12" r="9"/><path d="M9 8h5a2 2 0 0 1 0 4H9h6a2 2 0 0 1 0 4H9V8"/>',
  metals: '<path d="M3 20h18"/><path d="M5 20l2-6h10l2 6"/><path d="M8 14l2-6h4l2 6"/>',
  bonds: '<path d="M3 10l9-6 9 6"/><path d="M5 10v8"/><path d="M10 10v8"/><path d="M14 10v8"/><path d="M19 10v8"/><path d="M3 20h18"/>',
  income: '<path d="M12 3v18"/><path d="M17 7H9.5a3 3 0 0 0 0 6h5a3 3 0 0 1 0 6H6"/>',
  activity: '<path d="M4 7h16"/><path d="M4 12h16"/><path d="M4 17h10"/>',
  settings: '<circle cx="12" cy="12" r="3"/><path d="M12 2v3"/><path d="M12 19v3"/><path d="M4.9 4.9l2.1 2.1"/><path d="M17 17l2.1 2.1"/><path d="M2 12h3"/><path d="M19 12h3"/><path d="M4.9 19.1L7 17"/><path d="M17 7l2.1-2.1"/>',
  home: '<path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/>',
  holdings: '<rect x="3" y="7" width="18" height="13" rx="2"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>',
  more: '<path d="M4 7h16"/><path d="M4 12h16"/><path d="M4 17h16"/>',
  plus: '<path d="M12 5v14"/><path d="M5 12h14"/>',
  refresh: '<path d="M21 12a9 9 0 1 1-3-6.7L21 8"/><path d="M21 3v5h-5"/>',
  eye: '<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>',
  eyeOff: '<path d="M3 3l18 18"/><path d="M10.6 5.1A10.4 10.4 0 0 1 12 5c6.4 0 10 7 10 7a17.6 17.6 0 0 1-3.2 4.1M6.6 6.6C3.9 8.4 2 12 2 12s3.6 7 10 7a10 10 0 0 0 5.4-1.6"/><path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"/>',
  moon: '<path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/>',
  sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="M4.9 4.9l1.4 1.4"/><path d="M17.7 17.7l1.4 1.4"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="M4.9 19.1l1.4-1.4"/><path d="M17.7 6.3l1.4-1.4"/>',
  back: '<path d="M15 18l-6-6 6-6"/>',
  chev: '<path d="M9 18l6-6-6-6"/>',
  close: '<path d="M18 6L6 18"/><path d="M6 6l12 12"/>',
};
export const icon = (k: keyof typeof ICONS, size = 18) => ic(ICONS[k], size);

const NAV: [string, string, keyof typeof ICONS][] = [['overview', 'Overview', 'overview'], ['stocks', 'Stocks', 'stocks'], ['crypto', 'Crypto', 'crypto'],
  ['metals', 'Commodities', 'metals'], ['bonds', 'Bonds', 'bonds'], ['income', 'Income', 'income'], ['activity', 'Activity', 'activity'], ['settings', 'Settings', 'settings']];

export const SHELL = `<div class="app">
<aside class="side" aria-label="Portfolio Ledger">
  <div class="brandrow">${LOGO_SVG}<b>Portfolio Ledger</b></div>
  <nav class="tabs snav" role="tablist" aria-label="Sections">
    ${NAV.map(([t, l, i]) => `<button data-tab="${t}" role="tab" title="${l}">${icon(i)}<span>${l}</span></button>`).join('\n    ')}
  </nav>
  <div class="sfoot">
    <div class="scard"><div id="status"></div><button class="btn" id="refreshBtn">Refresh prices</button></div>
    <button class="ibtn srefresh" data-refresh aria-label="Refresh prices" title="Refresh prices">${icon('refresh')}</button>
    <div class="acct" id="acct"></div>
  </div>
</aside>
<div class="pagec"><main id="view" aria-live="polite"></main></div>
<nav class="bbar" role="tablist" aria-label="Sections">
  <button class="tab" data-ptab="overview" role="tab">${icon('home', 22)}Home</button>
  <button class="tab" data-ptab="holdings" role="tab">${icon('holdings', 22)}Holdings</button>
  <span class="plusw"><button class="plus" data-plus aria-label="Record">${icon('plus', 24)}</button></span>
  <button class="tab" data-ptab="income" role="tab">${icon('income', 22)}Income</button>
  <button class="tab" data-ptab="more" role="tab">${icon('more', 22)}More</button>
</nav>
</div>
<dialog id="dlg"></dialog>
<dialog id="cfm"><form method="dialog"><h2 id="cfmTitle"></h2><p class="dim" id="cfmMsg" style="margin-top:8px"></p>
  <div class="dlg-actions"><button class="btn" value="no">Cancel</button><button class="btn primary" id="cfmOk" value="yes">OK</button></div></form></dialog>
<input type="file" id="importFile" accept=".json,application/json" hidden>
<div id="toast" role="status"></div>
`;
